import { Button } from '@mui/material';
import classNames from 'classnames';

import './styles.scss';

interface InlineOptionProps {
  value: string;
  label: string;
  iconLeft?: React.ReactNode;
  selected: boolean;
  onClick: (value: string) => void;
  className?: string;
  isFilter?: boolean;
}

const InlineOption: React.FC<InlineOptionProps> = (prop) => {
  const { value, label, iconLeft, selected, onClick, isFilter } = prop;

  const renderLeftIcon = () => {
    if (iconLeft) {
      return <div className="inline-option-icon">{iconLeft}</div>;
    }

    return null;
  };

  const optionClass = classNames('inline-option', {
    selected: selected,
    'filter-variant': isFilter,
  });

  return (
    <Button onClick={() => onClick(value)} className={optionClass}>
      {renderLeftIcon()}
      <div className="option-text">{label}</div>
    </Button>
  );
};

export default InlineOption;
